import React from "react";

const Companies = ({ brands }) => {
  console.log({ brands });

  return (
    <section className="text-center bg--secondary py-5" id="brands">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2>Some brands and companies proud to have collaborated with.</h2>
            <p className="lead">
              I am grateful to have been a part of awesome projects for great
              companies and along side great people!
            </p>
          </div>
        </div>
        <div className="row mt--2">
          <div className="col-md-12">
            <ul className="list-inline list-inline--images">
              {brands.map((b, i) => (
                <li key={`brand-logo-${i}`}>
                  <img alt={b.brand} src={`img/logos/${b.image}`} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Companies;
